import common from './common.json';
import createPushNotification from './create-push-notification.json';
import pushNotificationSteps from './push-notification-steps.json';
import pushNotifications from './push-notifications.json';

export default {
  common,
  createPushNotification,
  pushNotificationSteps,
  pushNotifications,
};
